import React from "react";
import { cols } from "./ReportKit";

// Column sets for the tables that open when a number is clicked (used by the Sales overview).
export const clientColumns = (currency) => [
  cols.text("clientName", "Client", (v) => <strong>{v}</strong>),
  cols.text("industry", "Industry"),
  cols.text("source", "Source"),
  cols.text("assignedEmployeeName", "Owner", (v) => v || "Unassigned"),
  cols.date("createdAt", "Added"),
  cols.num("enquiryCount", "Enquiries"),
  cols.num("openEnquiries", "Open"),
  cols.num("approvedEnquiries", "Approved"),
  cols.num("rejectedEnquiries", "Rejected"),
  cols.num("totalValue", "Money", "CURRENCY", currency),
  cols.badge("status", "Status"),
];

export const leadColumns = () => [
  cols.text("leadName", "Lead", (v) => <strong>{v}</strong>),
  cols.text("industry", "Industry"),
  cols.text("source", "Source"),
  cols.badge("status", "Status"),
  cols.text("assignedEmployeeName", "Owner", (v) => v || "Unassigned"),
  cols.date("createdAt", "Added"),
  cols.num("daysOpen", "Days open"),
  cols.num("enquiryCount", "Enquiries"),
  cols.date("lastActivityAt", "Last news"),
  cols.date("convertedAt", "Became client"),
  cols.text("lostReason", "Lost reason"),
];

export const enquiryColumns = (currency) => [
  cols.text("enquiryCode", "Enquiry", (v) => <strong>{v}</strong>),
  cols.text("clientName", "Client"),
  cols.text("leadName", "Lead"),
  cols.text("stageName", "Stage"),
  cols.badge("status", "Status"),
  cols.badge("priority", "Priority"),
  cols.text("type", "Type"),
  cols.num("totalEstimateAmount", "Estimate", "CURRENCY", currency),
  cols.num("totalQuotationAmount", "Quote", "CURRENCY", currency),
  cols.date("expectedCloseDate", "Expected close"),
  cols.num("ageDays", "Age (days)"),
  cols.num("daysInCurrentStage", "In stage (days)"),
  cols.text("assignedEmployeeName", "Owner"),
  cols.date("createdAt", "Created"),
];

// An enquiry that has not been answered yet.
export const OPEN_ENQUIRY = (r) =>
  !/APPROV|REJECT|CLOSED|WON|LOST|CANCEL/i.test(String(r.status || ""));
